import { createFileRoute } from "@tanstack/react-router";
import { readSparkspreadPricesSparkspreadGet } from "@/client-admin";
import { SparkSpreadDashboardView } from "@/components/SparkSpreadDashboard/SparkSpreadDashboardView";
import { checkSuperUserPermission } from "@/lib/utils";

export const Route = createFileRoute("/_superuser/admin/sparkspread-dashboard")({
  component: AdminSparkSpreadDashboardPage,
  beforeLoad: async () => {
    checkSuperUserPermission("price-update");
  },
});

function AdminSparkSpreadDashboardPage() {
  return <SparkSpreadDashboardView queryKey={["spsp-admin"]} queryFn={() => readSparkspreadPricesSparkspreadGet()} />;
}
